export const loadImg = imgUrl => {
  return new Promise((resolve, reject) => {
    if (!imgUrl) {
      const errMsg = `请传入正确的图片链接`
      reject(errMsg)
      return
    }
    const img = new Image()
    img.src = imgUrl
    img.onload = () => {
      resolve(img)
    }
    img.onerror = () => {
      const errMsg = `图片加载失败#${imgUrl}`
      reject(errMsg)
    }
  })
}

export const loadImgArr = (imgArr = []) => {
  const promiseArr = imgArr.map(imgUrl => loadImg(imgUrl))
  return Promise.all(promiseArr)
}
